// extracted by mini-css-extract-plugin
module.exports = {"rightText":"CryptoPromo_rightText__XqIxp","formWrapper":"CryptoPromo_formWrapper__w8xEu"};